export enum SYSTEM_TYPE {
    MAC = 'mac',
    WIN = 'win',
}

export const getIncomeSource = () => {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('mtxx-pc') > -1) {
        return 'MTXX-PC';
    } else if (ua.indexOf('mtxx-linux') > -1) {
        return 'MTXX-LINUX';
    } else if (ua.indexOf('mtxx-mac') > -1) {
        return 'MTXX-MAC';
    }
    return 'MTXX-WEB';
};

/**
 * 判断是否是Mac系统电脑
 * @returns
 */
export const isMac = (ua: string) => {
    return /(macintosh)|(mac os x)/.test(ua);
};

/**
 * 判断是否是Window系统电脑
 * @returns
 */
export const isWin = (ua: string) => {
    return /(window)/.test(ua) && /(win32)|(wow32)|(win64)|(wow64)/.test(ua);
};

/**
 * 判断是否是Linux系统电脑
 * @returns
 */
export const isLinux = (ua: string) => {
    return /linux/.test(ua);
};

/**
 * 获取电脑系统类型
 * @returns
 */
export const getSysType = () => {
    const incomeSource = getIncomeSource();

    if (incomeSource === 'MTXX-MAC') {
        return SYSTEM_TYPE.MAC;
    }

    const ua = window.navigator.userAgent.toLowerCase();

    if (isMac(ua)) {
        return SYSTEM_TYPE.MAC;
    }
    if (isWin(ua)) {
        return SYSTEM_TYPE.WIN;
    }
    return SYSTEM_TYPE.WIN;
};
